import React from 'react'
import { Helmet } from 'react-helmet'
import { string } from 'prop-types'

const propTypes = {
  title: string,
  description: string,
  siteName: string,
  url: string,
  image: string,
}

const Facebook = ({ title, description, siteName, url, image }) => (
  <Helmet>
    <meta name="og:title" content={title} />
    <meta name="og:description" content={description} />
    <meta name="og:type" content="website" />
    <meta name="og:site_name" content={siteName} />
    <meta name="og:url" content={url} />
    <meta name="og:locale" content="pt_BR" />
    <meta name="og:image" content={image} />
    <meta name="image" property="og:image" content={image} />
    <meta name="og:image:type" content="image/jpg" />
    <meta name="og:image:width" content="1200" />
    <meta name="og:image:height" content="628" />
  </Helmet>
)

Facebook.propTypes = propTypes

export { Facebook }
